import moment from 'moment';
import styled from 'styled-components';
import ALink from './ALink';
import CircleImage, { CircleImageSize } from './CircleImage';
import FlexBox, { FlexGrow } from './FlexBox';
import { ClickableIcon } from './Icon';
import Modal from './Modal';
import Pill from './Pill';
import Avatar from '../assets/avatar.png';

type ActivityInfoModalProps = {
  isOpen?: boolean;
  setOpen: (x: boolean) => void;
  event: any;
};
const Title = styled.div`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  color: #353334;
`;
const Hr = styled.hr`
  width: 96%;
  border-color: #e7ebee;
  margin-top: 16px;
  margin-bottom: 16px;
`;
const CustomPill = styled(Pill)`
  padding: 5px 9px;
  background: #eefcf5;
  border-radius: 6px;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  /* identical to box height, or 143% */

  text-transform: uppercase;

  color: #1e9952;
`;
const Time = styled.span`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #848484;
`;
const Desc = styled.p`
  margin-top: 4px;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  /* or 157% */

  /* Text/Secondary */

  color: #848484;
`;
const CustomBox = styled(FlexBox)`
  margin-bottom: 18px;
`;

const ActivityInfoModal = ({
  isOpen,
  setOpen,
  event,
}: ActivityInfoModalProps): JSX.Element => {
  return (
    <>
      <Modal
        isOpen={isOpen || false}
        setOpen={setOpen}
        customStyle={{
          content: {
            maxWidth: '413px',
            padding: '24px',
            background: '#FFFFFF',
            border: '1px solid #E7EBEE',
            boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.07)',
            borderRadius: '8px',
          },
        }}>
        <CustomBox>
          <FlexGrow></FlexGrow>
          <ClickableIcon
            name="times"
            onClick={() => setOpen(false)}
            style={{ color: '#353334' }}
          />
        </CustomBox>
        <CustomBox>
          <FlexGrow>
            <Title>{event.title}{event.related_competency&&` [${event.related_competency.competency_code}]`}</Title>
          </FlexGrow>
        </CustomBox>
        <CustomBox>
          <FlexGrow>
            <Time style={{ marginRight: '5px' }}>
              {moment(event.date).format('dddd')}
            </Time>
            <Time style={{ textTransform: 'uppercase' }}>
              {event.startTime}
            </Time>
            <Time style={{ margin: '0 5px' }}>-</Time>
            <Time style={{ textTransform: 'uppercase' }}>{event.endTime}</Time>
            <Time style={{ margin: '0 5px' }}>
              {'('}
              {event.location}
              {')'}
            </Time>
          </FlexGrow>
        </CustomBox>
        <CustomBox>
          <FlexGrow>
            <CustomPill>{event.event_type}</CustomPill>
          </FlexGrow>
        </CustomBox>
         <CustomBox>
          <FlexGrow>
            <Title>Program</Title>
            <Desc>{event.program_name}</Desc>
          </FlexGrow>
        </CustomBox>
        {event.description&&<CustomBox>
          <FlexGrow>
            <Title>Description</Title>
            <Desc>{event.description}</Desc>
          </FlexGrow>
        </CustomBox>}
        {event.url&&<CustomBox>
          <FlexGrow>
            <Title>Links</Title>
            {event.url && (
              <ul
                style={{
                  padding: '0 12px',
                  color: '#848484',
                  margin: '4px 0 0 0',
                }}>
                <li>
                  <ALink
                    href={event.url}
                    style={{ textDecorationLine: 'underline' }}
                    color="#848484">
                    {event.url_label}
                  </ALink>
                </li>
              </ul>
            )}
          </FlexGrow>
        </CustomBox>}
        {event.related_competencies && (
          <CustomBox>
            <FlexGrow>
              <Title>Related Competencies</Title>
              <ul
                style={{
                  padding: '0 12px',
                  color: '#848484',
                  margin: '4px 0 0 0',
                }}>
                <li>
                  <ALink
                    style={{ textDecorationLine: 'underline' }}
                    color="#848484">
                    {event.related_competencies.title}
                  </ALink>
                </li>
              </ul>
            </FlexGrow>
          </CustomBox>
        )}
        <FlexBox>
          <FlexGrow>
            <Hr />
          </FlexGrow>
        </FlexBox>
        <FlexBox>
          <FlexGrow style={{ flexGrow: 0 }}>
            <CircleImage
              src={event.avatar || Avatar}
              size={CircleImageSize.medium}
            />
          </FlexGrow>
          <FlexGrow>
            <Title>{event.responsible_person}</Title>
          </FlexGrow>
        </FlexBox>
      </Modal>
    </>
  );
};

export default ActivityInfoModal;
